import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "@/App";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Is the current user a dispatcher?
 *
 * Admins always; otherwise the user's linked unit has to be one of the units
 * flagged is_dispatcher. Same test IncomingCallAlert.js makes inline, so the
 * alert panel and the hotline notification settings can't disagree about who
 * counts.
 *
 * Client-side this decides only what to SHOW — the backend resolves the same
 * question itself for the alert feed and the push audience.
 */
export function useIsDispatcher() {
  const { user } = useAuth();
  const [isDispatcher, setIsDispatcher] = useState(false);

  useEffect(() => {
    if (!user) {
      setIsDispatcher(false);
      return;
    }
    if (user.role === "admin") {
      setIsDispatcher(true);
      return;
    }
    if (!user.linked_unit) {
      setIsDispatcher(false);
      return;
    }
    let cancelled = false;
    axios
      .get(`${API}/units/dispatchers`, { withCredentials: true })
      .then((res) => {
        if (cancelled) return;
        const names = (res.data || []).map((d) => d.name);
        setIsDispatcher(names.includes(user.linked_unit));
      })
      .catch(() => {
        if (!cancelled) setIsDispatcher(false);
      });
    return () => { cancelled = true; };
  }, [user]);

  return isDispatcher;
}

export default useIsDispatcher;
